/*
  Auto-rotating product carousel for the revamped article body.

  Card markup is untouched — this only slides the track and syncs the dots.
  A single-card block is left completely alone.
*/
(function () {
  const AUTOPLAY_MIN = 1000;

  function initCarousel(root) {
    const track = root.querySelector('[data-rv-track]');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('.rv-carousel__slide'));
    if (slides.length < 2) return;

    const dots = Array.from(root.querySelectorAll('[data-rv-dot]'));
    const interval = Math.max(parseInt(root.dataset.interval, 10) || 5000, AUTOPLAY_MIN);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let index = 0;
    let timer = null;

    function show(next) {
      index = (next + slides.length) % slides.length;
      track.style.transform = 'translateX(' + index * -100 + '%)';
      slides.forEach(function (slide, i) {
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (reduceMotion) return;
      stop();
      timer = setInterval(function () {
        show(index + 1);
      }, interval);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.rvDot, 10) || 0);
        start();
      });
    });

    // Don't rotate a card out from under someone reading or using it.
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // Don't burn cycles while the carousel is off-screen or the tab is hidden.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) start();
          else stop();
        });
      }, { threshold: 0.2 }).observe(root);
    } else {
      start();
    }

    root.classList.add('rv-carousel--ready');
    show(0);
  }

  function init() {
    document.querySelectorAll('[data-rv-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
